import actions from './actions';
import getters from './getters';
import mutations from './mutations';

/**
 * Episode module state.
 *
 * @returns {object} Episode state.
 */
const state = () => ({
    episodes: null,
    episodesCount: {},
    totalPages: 0,
});

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
